import {ScoreCalculator} from '../common/score-calculator';
import {PlacedBin} from '../placed-bin';

export class CompactnessScoreCalculator extends ScoreCalculator {

    public override calc(placedBin: PlacedBin): number {
        const bins: PlacedBin[] = this.placedBins.concat([placedBin]);
        const spaceW = Math.max(...bins.map(bin => bin.right)) - Math.min(...bins.map(bin => bin.x));
        const spaceH = Math.max(...bins.map(bin => bin.bottom)) - Math.min(...bins.map(bin => bin.y));

        const spaceArea = spaceW * spaceH;
        const binsArea = bins.reduce((Area, bin) => Area + (bin.w * bin.h), 0);

        return Math.round(binsArea * 100 / spaceArea);
    }

}
